import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@app/shared/services/api/api.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { Observable, of, combineLatest } from 'rxjs';
import { switchMap, filter, catchError, map, first } from 'rxjs/operators';
import { AuthService } from '@app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardNotificationService extends ApiService {
  private readonly baseUri = 'socrates-base/ep/notifications/api/applicationalerts/platforms/b2m/grouptypes/municipality/groups';

  constructor(private _httpClient: HttpClient, private userMunicipalitiesService: UserMunicipalitiesService, private authService: AuthService) {
    super(_httpClient);
  }

  getApplicationAlerts(municipalityKey: string, userGuid: string): Observable<any[]> {
    if (!municipalityKey || !userGuid) {
      return of([]);
    }
    const url = `${this.baseUri}/${municipalityKey}/users/${userGuid}`;
    return this._httpClient.get<any[]>(this.endpoint(url));
  }

  loadApplicationAlerts(): Observable<boolean> {
    return combineLatest([this.userMunicipalitiesService.currentMunicipality$, of(this.authService.currentUser.guid)]).pipe(
      filter(([municipality, userGuid]) => !!municipality?.key && !!userGuid),
      switchMap(([municipality, userGuid]) =>
        this.getApplicationAlerts(municipality.key, userGuid).pipe(
          first(),
          map((alerts) => Array.isArray(alerts) && alerts.length > 0),
          catchError((_) => {
            return of(false);
          })
        )
      )
    );
  }
}
